import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './sensor-hardware.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import DoNotShowInProduction from 'app/shared/components/do-not-show-in-production/do-not-show-in-production.component';

export const SensorHardwareDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const sensorHardwareEntity = useAppSelector(state => state.sensorHardware.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="sensorHardwareDetailsHeading">
          <Translate contentKey="fleetSenseApp.sensorHardware.detail.title">SensorHardware</Translate>
        </h2>
        <dl className="jh-entity-details">
          <DoNotShowInProduction>
            <dt>
              <span id="id">
                <Translate contentKey="global.field.id">ID</Translate>
              </span>
            </dt>
            <dd>{sensorHardwareEntity.id}</dd>
          </DoNotShowInProduction>
          {/* <dt>
            <span id="manufacturer">
              <Translate contentKey="fleetSenseApp.sensorHardware.manufacturer">Manufacturer</Translate>
            </span>
          </dt>
          <dd>{sensorHardwareEntity.manufacturer}</dd>
          <dt>
            <span id="model">
              <Translate contentKey="fleetSenseApp.sensorHardware.model">Model</Translate>
            </span>
          </dt>
          <dd>{sensorHardwareEntity.model}</dd> */}
          <dt>
            <span id="description">
              <Translate contentKey="fleetSenseApp.sensorHardware.description">Description</Translate>
            </span>
          </dt>
          <dd>{sensorHardwareEntity.description}</dd>
          <dt>
            <span id="equation">
              <Translate contentKey="fleetSenseApp.sensorHardware.equation">Equation</Translate>
            </span>
          </dt>
          <dd>{sensorHardwareEntity.equation}</dd>
        </dl>
        <Button onClick={() => props.history.goBack()} replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/sensor-hardware/${sensorHardwareEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default SensorHardwareDetail;
